/**
 * Picks the display name for `value` in `lang` from the backend `localizedNames`
 * map, falling back to English, then the raw `name`. For expansions (which carry an
 * `abbreviation`), the abbreviation is appended -- matching the old server-rendered
 * `name` of "Homelands (HML)" while keeping the stored map values bare.
 */
export function localizedName(value: any, lang: string): string | undefined {
  if (value == null) {
    return undefined;
  }
  const map = value.localizedNames;
  let base: string | undefined;
  if (map && typeof map === 'object') {
    base = map[lang] || map['en'] || value.name;
  } else {
    base = value.name;
  }
  if (base == null) {
    return undefined;
  }
  if (value.abbreviation) {
    return `${base} (${value.abbreviation})`;
  }
  return base;
}

/**
 * The name a cart line's controls are announced by: the product's own localized name, or its card
 * data's when the product carries none. One statement of the fallback, shared by every per-line
 * control that names its row.
 */
export function productLineName(product: any, lang: string): string | undefined {
  return localizedName(product, lang) || localizedName(product?.cardData, lang);
}
